module.exports = __webpack_public_path__ + "img/icon-360.9fefba73.svg";